import { NewSurvey } from "../../pages/index";
const protectedRoutes = [
  {
    path: "user/new-surveys",
    element: <NewSurvey />,
  },
];

export default protectedRoutes;
